// src/api/http.js
import API_BASE_URL from "./baseUrl";
const BASE = API_BASE_URL;

// adjust this to wherever you store token (localStorage/sessionStorage/context)
function getToken() {
  try {
    return (
      localStorage.getItem("token") ||              // ✅ your primary key everywhere else
      localStorage.getItem("auth_token") ||
      localStorage.getItem("jwt") ||
      sessionStorage.getItem("auth_token")
    );
  } catch {
    return null;
  }
}

export async function api(path, init = {}) {
  const url = path.startsWith("http") ? path : `${BASE}${path}`;
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    ...(init.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const res = await fetch(url, { ...init, headers, credentials: "include" });
  return res;
}
